module.exports = __webpack_public_path__ + "media/swipe.11f5cea8.mp3";